import * as React from 'react';

import DisclaimerPage from './create-your-account/DisclaimerPage';
import BasicsPage from './create-your-account/BasicsPage';
import LifestylePage from './create-your-account/LifestylePage';
import ActivitiesPage from './create-your-account/ActivitiesPage';
import MedicalHistoryPage from './create-your-account/MedicalHistoryPage';
import BillingReviewPage from './billing-review/BillingReviewPage';
import WorkflowProgress from '../WorkflowProgress';
import SignUpPage from '../enrollment/SignUpPage';
import OptionalBeneficiaryContainer from './billing-review/OptionalBeneficiaryContainer';

interface Props {
	questionnaire?: any;
	match?: any;
}
const EnrollmentWorkflow: React.StatelessComponent<Props> = props => {
	let Page = null;
	let activeStep = 0;

	if (props.match.params.enrollmentPage === 'my-pledge') {
		Page = DisclaimerPage;
		activeStep = 0;
	} else if (props.match.params.enrollmentPage === 'basics') {
		Page = BasicsPage;
		activeStep = 1;
	} else if (props.match.params.enrollmentPage === 'lifestyle') {
		Page = LifestylePage;
		activeStep = 2;
	} else if (props.match.params.enrollmentPage === 'activities') {
		Page = ActivitiesPage;
		activeStep = 3;
	} else if (props.match.params.enrollmentPage === 'medical-history') {
		Page = MedicalHistoryPage;
		activeStep = 4;
	} else if (props.match.params.enrollmentPage === 'review') {
		Page = BillingReviewPage;
		activeStep = 0;
	} else if (props.match.params.enrollmentPage === 'beneficiary') {
		Page = OptionalBeneficiaryContainer;
		activeStep = 1;
	} else if (props.match.params.enrollmentPage === 'billing') {
		Page = BillingReviewPage;
		activeStep = 2;
	} else if (props.match.params.enrollmentPage === 'sign-up') {
		Page = SignUpPage;
		activeStep = 3;
	}

	return (
		<div>
			{!(props.match.params.enrollmentPage === 'billing'
				|| props.match.params.enrollmentPage === 'beneficiary'
				|| props.match.params.enrollmentPage === 'review'
				|| props.match.params.enrollmentPage === 'sign-up') && (
					<WorkflowProgress
						wrapperClassName="mb-4 text-secondary enrollment-progress-bar"
						buttonClassName="btn-outline-secondary"
						steps={[
							{
								label: 'My Pledge',
								to: `/quote/${props.match.params.workflow}/enrollment/my-pledge`,
								incomplete: false
							},
							{
								label: 'Basics',
								to: `/quote/${props.match.params.workflow}/enrollment/basics`,
								incomplete: false
							},
							{
								label: 'Lifestyle',
								to: `/quote/${props.match.params.workflow}/enrollment/lifestyle`,
								incomplete: false
							},
							{
								label: 'Activities',
								to: `/quote/${props.match.params.workflow}/enrollment/activities`,
								incomplete: false
							},
							{
								label: 'Medical History',
								to: `/quote/${props.match.params.workflow}/enrollment/medical-history`,
								incomplete: false
							}
						]}
						activeStep={activeStep}
					/>
				)}
			{(props.match.params.enrollmentPage === 'billing'
				|| props.match.params.enrollmentPage === 'beneficiary'
				|| props.match.params.enrollmentPage === 'review'
				|| props.match.params.enrollmentPage === 'sign-up') && (
					<WorkflowProgress
						wrapperClassName="mb-4 text-secondary enrollment-progress-bar"
						buttonClassName="btn-outline-secondary"
						steps={[
							{
								label: 'Review',
								to: `/quote/${props.match.params.workflow}/enrollment/review`,
								incomplete: Page === SignUpPage && activeStep === 3
							},
							{
								label: 'Beneficiaries',
								// if user already filled up info on beneficiary page then display disbursement page instead
								to: activeStep < 2 ? `/quote/${props.match.params.workflow}/enrollment/beneficiary` :
									`/quote/${props.match.params.workflow}/enrollment/beneficiary#2`,
								incomplete: Page === SignUpPage && activeStep === 3
							},
							{
								label: 'Billing',
								to: `/quote/${props.match.params.workflow}/enrollment/billing`,
								incomplete: Page === SignUpPage && activeStep === 3
							},
							{
								label: 'Sign Up',
								to: `/quote/${props.match.params.workflow}/enrollment/sign-up`,
								incomplete: Page === SignUpPage && activeStep === 3
							}
						]}
						activeStep={activeStep}
					/>
				)}
			{Page !== null ? <Page {...props} /> : null}
		</div>
	);
};

export default EnrollmentWorkflow;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/EnrollmentWorkflow.tsx